import type { ReactElement } from "react";
import { useMemo } from "react";

import type { ChipItem } from "app/pages/sales-intelligence/common-components/filters-panel";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import { FilterResultContainer } from "app/pages/sales-intelligence/common-components/filters-panel/components/styles";
import type FindTopLevelDomainsFilter from "app/pages/sales-intelligence/modules/leads-search-filters/models/TopLevelDomainsFilter/TopLevelDomainsFilter";

import { MAX_CHIPS_GROUP_AMOUNT } from "../../../constants";

const TopLevelDomainsFilterResult = ({
    value,
    onFilterUpdate,
    onGetLifecycleStatus,
    isExpanded,
    onFilterValueRemove,
}: IFilterViewBaseProps<FindTopLevelDomainsFilter>): ReactElement | null => {
    const handleRemove = (id: string) => {
        const values = value?.values?.filter((val: string) => val !== id);

        if (values?.length) {
            const newValue = { ...value, values };

            onFilterValueRemove?.(newValue);
            onFilterUpdate(newValue);
        } else {
            onFilterUpdate();
            onFilterValueRemove?.();
        }
    };

    const chipItems: ChipItem[] = useMemo(() => {
        if (!value?.values) {
            return [];
        }

        return value.values.map((item: string) => {
            return {
                id: item,
                text: item,
                chipStatus: onGetLifecycleStatus?.(item),
            };
        });
    }, [value, onGetLifecycleStatus]);

    if (!chipItems.length) {
        return null;
    }

    return (
        <FilterResultContainer>
            <LimitedChipItems
                items={chipItems}
                onDelete={handleRemove}
                maxItems={MAX_CHIPS_GROUP_AMOUNT}
                isTabExpanded={isExpanded}
            />
        </FilterResultContainer>
    );
};

export default TopLevelDomainsFilterResult;
